import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../api/firebase/config';
import { gray80, primaryButtonBackgroundColor, white } from '../../../constants/colors';
import MetaTitle from '../../utils/MetaTitle';
import logoImage from '../../assets/logo_color.png';

const MESSAGE =
  '貴社のセキュリティ設定により、SSO（SAML）でのログインが必要です。\nログイン画面の「SSO でサインイン」からログインし直してください。';

const styles = {
  // メンテナンス画面 / MfaSetupRequired と同じ構成: 白背景・公式カラーロゴを中央配置
  container: {
    alignItems: 'center',
    backgroundColor: white,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100vh',
    px: '24px',
    py: '48px',
    width: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '560px',
    textAlign: 'center',
    width: '100%',
  },
  logo: {
    height: 'auto',
    width: '300px',
    '@media screen and (max-width:600px)': {
      width: '240px',
    },
  },
  message: {
    color: gray80,
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: 1.8,
    mt: '40px',
    whiteSpace: 'pre-wrap',
    '@media screen and (max-width:600px)': {
      fontSize: '16px',
      mt: '32px',
    },
  },
  actionButton: {
    height: '44px',
    minWidth: '200px',
    mt: '32px',
    '@media screen and (max-width:600px)': {
      mt: '24px',
    },
  },
};

/**
 * SAML 必須モード時の SSO 再ログイン要求画面（#2983）。
 * SAML 必須テナントのメンバーがメール/パスワード等の非 SAML セッションで
 * ログインしている場合に、通常画面の代わりに表示する。
 */
const SamlSignInRequired: React.FC = () => {
  const navigate = useNavigate();

  const handleRelogin = async (): Promise<void> => {
    await signOut(auth).catch(() => undefined);
    navigate('/');
  };

  return (
    <Box sx={styles.container}>
      <MetaTitle customTitle="SSO ログインが必要です" />
      <Box sx={styles.content}>
        <Box component="img" src={logoImage} alt="Gen Drive" sx={styles.logo} />
        <Typography sx={styles.message}>{MESSAGE}</Typography>
        <Button
          onClick={(): void => void handleRelogin()}
          sx={[primaryButtonBackgroundColor, styles.actionButton]}
        >
          ログイン画面へ
        </Button>
      </Box>
    </Box>
  );
};

export default SamlSignInRequired;
